import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import { DataGrid, GridColDef, GridValueGetterParams, renderActionsCell } from '@mui/x-data-grid';
import { useDispatch, useSelector } from "react-redux";
import { Divider, Grid } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import moment from "moment";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Tooltip } from "@mui/material";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import FilterListIcon from '@mui/icons-material/FilterList';
import { Space, Table, Tag } from 'antd';
import VizHeader from "../../Component/VizHeader/VizHeader";
import VizParagraph from "../../Component/VizParagraph/VizParagraph";

export default function TableComponentForShared() {
	const sharedFolderData = useSelector((state) => state.sharedFolderCMReducer);
	const dispatch = useDispatch();
	const { advanceFilterModalToggle,getFolderNameForGDriveDocs,getIdForGoogleDriveDocs,getFrequencyNameForGoogleDrive } = bindActionCreators(Actions, dispatch);
	const [getFolderName,setFolderName] = useState('');
	const [getId,setId] = useState(null);
	const [getFrequncyName, setFrequencyName] = useState('')
	const [selectedRows, setSelectedRows] = React.useState([]);

	
	const columns = [
		{
			field:'id',
			headerName:'ID',
			headerClassName:'column-header-shared-folder',
			sortable:false,
			width:100,
			valueGetter:(params)=>{
				return `${(params.row.id)}`
			},
			renderHeader: () => (
				<>
					<div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between'}}>
						<strong>
							{"ID"}
						</strong>
						<div>
						<FilterListIcon sx={{margin:'5px'}} />
						</div>
					</div>
				</>
			),
		},
		{
			field: 'folderName',
			headerName: 'Folder Name',
			headerClassName: 'column-header-shared-folder',
			sortable: false,
			width: 200,
			valueGetter:(params)=>{
				return `${(params.row.folderName)}`
			},
			renderHeader: () => (
				<>
					<div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between'}}>
						<div>
							<strong>
							{"Folder Name"}
							</strong>
						</div>
						<div>
						<FilterListIcon sx={{margin:'5px'}} />
						</div>
					</div>
				</>
			),
		},
		{
			field: 'createdDate',
			headerName: 'Date Submitted',
			headerClassName: 'column-header-shared-folder',
			flex: 0.1,
			valueGetter: (params) =>
				`${(moment(params.row.createdDate).format('LL'))}`,
			sortable: false,
			minWidth: 150,
			align:'left',
			renderHeader: () => (
				<>
					<div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between'}}>
						<div>
							<strong>
							{"Date Submitted"}
							</strong>
						</div>
						<div>
						<FilterListIcon sx={{margin:'5px'}} />
						</div>
					</div>
				</>
			),
		},
		{
			field: 'modifiedDate',
			headerName: 'Date Checked',
			headerClassName: 'column-header-shared-folder',
			type: 'number',
			editable: false,
			valueGetter: (params) =>
				`${(moment(params.row.modifiedDate).format('LL'))}`,
			sortable: false,
			minWidth: 150,
			flex:0.1,
			headerAlign:"left",
			align:'left',
			renderHeader: () => (
				<>
					<div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between'}}>
						<div>
							<strong>
							{"Date Checked"}
							</strong>
						</div>
						<div>
						<FilterListIcon sx={{margin:'5px'}} />
						</div>
					</div>
				</>
			),
		},
		{
			field: 'folderUrl',
			headerName: 'Folder Link',
			headerClassName: 'column-header-shared-folder',
			sortable: false,
			renderCell: (params) => {
				return <Tooltip title={params.row.folderUrl}>
					<a href={`${params.row.folderUrl}`} style={{color:'var(--light_color_shade)',fontSize:'14px'}} target="_blank">{params.row.folderUrl}</a>
				</Tooltip>
			},
			width: 'auto',
			flex:1,
			renderHeader: () => (
				<>
					<div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between'}}>
						<div>
							<strong>
							{"Folder Link"}
							</strong>
						</div>
						<div>
						<FilterListIcon sx={{margin:'5px'}} />
						</div>
					</div>
				</>
			),
		},
		{
			field: 'folderFrequency',
			headerName: 'Check Frequency',
			headerClassName: 'column-header-shared-folder',
			type: 'number',
			editable: false,
			sortable: false,
			minWidth: 160,
			// flex:0.1,
			valueGetter: (params) => {
				setFrequencyName(params.row.folderFrequency)
				return params.row.folderFrequency
			},
			headerAlign:'left',
			align:'left',
			renderHeader: () => (
				<>
					<div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between'}}>
						<div>
							<strong>
							{"Check Frequency"}
							</strong>
						</div>
					</div>
				</>
			),
		},
		{
			field: 'options',
			headerName: 'Options',
			headerClassName: 'column-header-shared-folder',
			type: 'number',
			editable: false,
			renderCell: (params) => {
				return <DropdownComponent id={params.row.id} frequency={params.row.folderFrequency} folderName={params.row.folderName} />
			},
			sortable: false,
			minWidth: 150,
			// flex:0.1,
			headerAlign:'left',
			align:'left',
			renderHeader: () => (
				<>
					<div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between'}}>
						<div>
							<strong>
							{"Options"}
							</strong>
						</div>
					</div>
				</>
			),
		},
	];

	const renderColumns = [
		{
			title: <VizHeader type={5} isBold={true}>{"ID"}</VizHeader>,
			dataIndex: 'id',
			key: 'id',
			render:(text)=><span style={{fontWeight:300,fontSize:'13px'}}>{text}</span>

		},
		{
			title: <VizHeader type={5} isBold={true}>{"Folder Name"}</VizHeader>,
			dataIndex: 'folderName',
			key: 'folderName',
			render: (text) => <span style={{fontWeight:300,fontSize:'13px'}}>
				{text}</span>
		},
		{
			title: <VizHeader type={5} isBold={true}>{"Date Submitted"}</VizHeader>,
			dataIndex: 'createdDate',
			key: 'createdDate',
			render: (text) => <span style={{fontSize:'13px',fontWeight:300}}>{moment(text).format('MMM DD, YYYY')}</span>
		},
		{
			title: <VizHeader type={5} isBold={true}>{"Date Checked"}</VizHeader>,
			dataIndex: 'modifiedDate',
			key: 'modifiedDate',
			render: (text) => <span style={{fontSize:'13px',fontWeight:300}}>{moment(text).format('MMM DD, YYYY')}</span>
		},
		{
			title: <VizHeader type={5} isBold={true}>{"Folder Link"}</VizHeader>,
			dataIndex: 'folderUrl',
			key: 'folderUrl',
			render: (text) => <a style={{fontWeight:300,fontSize:'13px'}} href={text} target="__blank">{text}</a>,
			width:300
		},
		{
			title: <VizHeader type={5} isBold={true}>{"Check Frequency"}</VizHeader>,
			dataIndex: 'folderFrequency',
			key: 'folderFrequency',
			render: (text) => <span style={{fontWeight:300,fontSize:'13px'}}>{text}</span>
		},
		{
			title: <VizHeader type={5} isBold={true}>{"Options"}</VizHeader>,
			key: 'options',
			render: (_, record) => (
				// <Space size="middle">
				<>
					<div>
					<DropdownComponent id={record.id} frequency={record.folderFrequency} folderName={record.folderName} />
					</div>
				{/* </Space> */}
				</>
			),
			width: 100
		}
	]

	const DropdownComponent = (props) => {
		const [anchorEl, setAnchorEl] = React.useState(null);
		const open = Boolean(anchorEl);
		const handleClick = (event) => {
			setAnchorEl(event.currentTarget);

		};
		const handleClose = () => {
			setAnchorEl(null);
		};

		const onClickOpenModal = (e) => {
			// setAnchorEl(null);
			if (e.target.innerText === "Edit") {
				advanceFilterModalToggle({ bool: true, value: "sharedFoldersCM" })
				getFolderNameForGDriveDocs(props.folderName)
				getIdForGoogleDriveDocs(props.id);
				getFrequencyNameForGoogleDrive(props.frequency);
			}
			if (e.target.innerText === "Remove") {
				advanceFilterModalToggle({ bool: true, value: "deleteGDriveConfirm" })
				getFolderNameForGDriveDocs(props.folderName)
				getIdForGoogleDriveDocs(props.id);
				getFrequencyNameForGoogleDrive(props.frequency);
			}
		}

		useEffect(()=>{

		},[])
		return (<>
			<Button
				id="basic-button"
				aria-controls={open ? 'basic-menu' : undefined}
				aria-haspopup="true"
				aria-expanded={open ? 'true' : undefined}
				onClick={handleClick}
				disableRipple={true}
				disableFocusRipple={true}
				sx={{'&:hover':{backgroundColor:'transparent'}}}
			>
				<IconButton disableRipple aria-label="more">
					<MoreVertIcon />
				</IconButton>
			</Button>
			<Menu
				disableScrollLock={true}
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
			>
				<MenuItem sx={{
					"& .MuiMenuItem-root:hover": {
						backgroundColor: "red"
					},
					fontSize:'14px'
				}} onClick={onClickOpenModal}>Edit</MenuItem>
				<Divider />
				<MenuItem sx={{fontSize:'14px'}} onClick={onClickOpenModal}>Remove</MenuItem>
			</Menu>
		</>)
	}

	useEffect(()=>{

	},[])


	return (
		<>
			<Grid container xs={12} sm={12} md={12}>
				<Box sx={{
					height: 'auto', width: '100%',
					'.ant-table-tbody > tr.ant-table-row-level-1:hover > td': {
						background: "unset"
					}
				}}>
					<DataGrid
						rows={sharedFolderData?.gdrivedocs}
						columns={columns}
						initialState={{
							pagination: {
								paginationModel: {
									pageSize: 5,
								},
							},
						}}
						pageSizeOptions={[5]}
						checkboxSelection={false}
						disableRowSelectionOnClick
						// autoHeight={true}
						// autoPageSize={true}
						autoHeight
						sx={{
							".MuiDataGrid-columnHeader:focus":{
								outline:'none !important'
							},
							'.MuiDataGrid-columnHeaderTitle': {
								fontWeight: 'bold !important',
								color: 'var(--questionText_color)',
								fontSize: '16px',
							},
							"&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
								outline: "none !important",
							 },
							fontWeight: 300
						}}
						disableColumnMenu={true}
						hideFooterPagination={true}
						// onRowClick={(params) => {
						// 	setFolderName(params.row.folderName)
						// 	setFrequencyName(params.row.frequency)
						// }}
					/>
					{/* <Table rowClassName={(record, index) =>
						index % 2 === 0 ? "table-row-light" : "table-row-dark"
					} tableLayout="fixed" dataSource={sharedFolderData?.gdrivedocs} columns={renderColumns} /> */}
				</Box>
			</Grid>
		</>
	)
}